import { render, staticRenderFns } from "./FMCreateFolder.vue?vue&type=template&id=14a8b3c0&scoped=true"
import script from "./FMCreateFolder.vue?vue&type=script&lang=js"
export * from "./FMCreateFolder.vue?vue&type=script&lang=js"
import style0 from "./FMCreateFolder.vue?vue&type=style&index=0&id=14a8b3c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a8b3c0",
  null
  
)

export default component.exports